module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEHSURBVEhL5ZQ9kkFBGEU7MLFIlcgCWIcymXhk2AKJhMxqJhOaHUyI1BLYAfeo91W1p73uHj/JnKpT9XR/97by0+5fUZfrQp6fwlQu5Vj+ylMhz6yxx8yfaEorjMlsNl0ZKgvJbBZ9uZOhspDMkkliJkMlKZKNMpShcIpko9TkXoYKqiRDNsojB3zIKI98RCMZ5eVfMrz0Z2rk/NE+ZTJz2ZK5VwUZspUwQODr8sq5iUy97AaSvbuHWDluZEP62HX9Uzz7MLuVlr85xC83D/JbrmRPlmGNPWaOspy/OqQjF9J/Fybr92CvPE8H63QG8Q+pKjf8Q8hGsUBKuZGVacuccoMM2Xfi3BklC9oZJ8UbqwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-certificate/dark/24.png
// module id = 1934
// module chunks = 2